/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Nrl_Trackselected2Inputs */

const en_coinvestments_nrl_trackselected2 = /** @type {(inputs: Coinvestments_Nrl_Trackselected2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "Track {count} selected" |
*
* @param {Coinvestments_Nrl_Trackselected2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_trackselected2 = /** @type {((inputs: Coinvestments_Nrl_Trackselected2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Trackselected2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_trackselected2(inputs)
});
export { coinvestments_nrl_trackselected2 as "coInvestments_nrl_trackSelected" }